module.exports = __webpack_public_path__ + "img/loan-status3.c79857ba.png";